import { useState, useEffect, ReactNode } from "react";

import "./style.scss";
import LogoTiva from "../../assets/logo-tiva-white.svg";
import SmallLogoTiva from "../../assets/logo-tiva-red.svg";
import { Logo } from "../../common/enums/logo.enum";
import { ThemeContainer } from "../../common/containers/theme/theme.container";
import { getLogoImg } from "../../common/utilities/logo/logo.util";

export const AuthTemplate = ({ children }: { children: ReactNode }) => {
    const { logo, color } = ThemeContainer.useContainer();
    const [logoImg, setLogoImg] = useState<string>(LogoTiva);
    const [showTivaLogo, setShowTivaLogo] = useState<boolean>(false);

    useEffect(() => {
        setShowTivaLogo(logo !== Logo.default);
        setLogoImg(getLogoImg(logo));
    }, [logo]);

    return (
        <div className="auth-template">
            {showTivaLogo && (
                <div className="auth-template-tiva">
                    <img src={SmallLogoTiva} className="auth-template-tiva__img" alt="" />
                </div>
            )}
            <div className="auth-template-content">{children}</div>
            <div className="auth-template-logo" style={{ background: color }}>
                <img src={logoImg} className="auth-template-logo__img" alt="" />
            </div>
        </div>
    );
};
